/**
 * @module interface
 */
export interface V2TimFriendCheckResult {
    userID: string;
    resultCode: number;
    resultInfo?: string;
    resultType: number;
}
